import { render, staticRenderFns } from "./RecordingsList.vue?vue&type=template&id=2cb6124e&scoped=true&"
import script from "./RecordingsList.vue?vue&type=script&lang=js&"
export * from "./RecordingsList.vue?vue&type=script&lang=js&"
import style0 from "./RecordingsList.vue?vue&type=style&index=0&id=2cb6124e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6124e",
  null
  
)

export default component.exports